<template>
  <div class="order">
    <div class="order_nav">
      <navbar
        title="选择提现订单"
        :lefticon="lefticon"
        :lefticonheight="1.8"
        :lefticonwidth="1.8"
        :fontweight="700"
        :fontsize="'1.8rem'"
        @goback="goBack(false)"
      />
    </div>
    <div class="all">
      <p class="search" @click="showDatePopup">
        <span>{{ selectData }}</span>
        <span class="icon"><van-icon name="play" /></span>
      </p>
      <van-pull-refresh
        v-model="isLoading"
        @refresh="onRefresh"
        v-if="list.length != 0"
      >
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="已经是全部内容了"
          @load="onLoad"
        >
          <van-cell class="lists" v-for="(item, index) in list" :key="index">
            <div>
              <van-row>
                <van-col span="24" class="title">
                  订单编号：{{ item.ordersn }}
                  <span>商品id：{{ item.real_goods_id }}</span>
                </van-col>
                <van-col span="24" class="goods_info">
                  <div class="info_box">
                    <div class="left">
                      <img
                        class="select_icon"
                        v-show="!item.select"
                        @click="selectSingle(item)"
                        src="@/assets/purchaseSupplier/common/no_select.png"
                      />
                      <img
                        class="select_icon"
                        v-show="item.select"
                        @click="selectSingle(item)"
                        src="@/assets/purchaseSupplier/withdraw/selected.png"
                      />
                      <img
                        class="pro_img"
                        :src="item.sku_image"
                        @error="nofind()"
                      />
                      <p class="goods_name">{{ item.goods_name }}</p>
                      <p class="spec">
                        <span v-if="item.specification_name">规格：</span
                        >{{ item.specification_name }}
                      </p>
                    </div>
                    <div class="right">
                      <p><span>￥</span>{{ item.cost_price }}</p>
                      <p class="quantity">X{{ item.goods_quantity }}</p>
                    </div>
                  </div>
                  <p class="money">完成时间：{{ item.confirm_time }}</p>
                  <p class="money postage">运费：￥{{ item.goods_postage }}</p>
                  <p class="account">
                    合计金额：<span>￥{{ item.goods_amount }}</span>
                  </p>
                </van-col>
              </van-row>
            </div>
          </van-cell>
        </van-list>
      </van-pull-refresh>

      <van-row class="empty" v-if="list.length == 0 && !hasList">
        <van-col class="emptyMsg" span="24">
          <img src="../../../assets/purchaseSupplier/common/no_info.png" />
          <p class="tip">无内容</p>
        </van-col>
      </van-row>

      <div class="loading" v-if="list.length <= 0 && hasList">
        <img src="../../../assets/accountAgent/common/loading.gif" />
      </div>

      <van-popup v-model="showdate" position="bottom">
        <van-row class="title">
          <van-col span="12" :class="{ active: selectFirst }">
            <p class="decs">开始日期</p>
            <p>{{ startTime }}</p>
            <span></span>
          </van-col>
          <van-col span="12" :class="{ active: !selectFirst }">
            <p class="decs">结束日期</p>
            <p>{{ endTime }}</p>
            <span></span>
          </van-col>
        </van-row>
        <van-datetime-picker
          :formatter="formatter"
          v-model="currentDate"
          type="date"
          :min-date="minDate"
          :item-height="'5.1rem'"
          :visible-item-count="5"
          @change="changeTime($event)"
        />
        <p class="btns">
          <btn
            class="left"
            :btntext="'重置'"
            :btnwidth="'16.6rem'"
            :height="'4.4rem'"
            :bgcolor="'#fff'"
            :borderradius="'0.4rem'"
            :btncolor="'#333'"
            :fontsize="'1.6rem'"
            :btnborder="'solid 0.05rem #ccc'"
            @btnClick="allTime"
          />
          <btn
            :btntext="selectFirst ? '下一步' : '确定'"
            :btnwidth="'16.6rem'"
            :height="'4.4rem'"
            :bgcolor="'linear-gradient(to right, #FC740C, #F41A3C)'"
            :borderradius="'0.4rem'"
            :btncolor="'#fff'"
            :fontsize="'1.6rem'"
            @btnClick="confirm"
          />
        </p>
      </van-popup>
    </div>

    <div class="countMsg">
      <div class="money">
        已选金额：<span>￥{{ selectMoney }}</span>
        <div class="seleceInfo">
          <p class="selectedInfo">
            已勾选<span>{{ slectOrderId.length }}</span
            >条
          </p>
          <p class="allInfo">共{{ allList }}条</p>
        </div>
      </div>
      <p class="select">
        <img
          v-show="!allSelect"
          @click="selectAll()"
          src="@/assets/purchaseSupplier/common/no_select.png"
        />
        <img
          v-show="allSelect"
          @click="notSelectAll()"
          src="@/assets/purchaseSupplier/withdraw/selected.png"
        />
        全选
      </p>
      <btn
        class="confirm_btn"
        :btntext="'生成提现明细'"
        :btnwidth="'16.5rem'"
        :height="'4.4rem'"
        :bgcolor="'linear-gradient(to right, #FC740C, #F41A3C)'"
        :borderradius="'2.2rem'"
        :btncolor="'#fff'"
        :fontsize="'1.6rem'"
        @btnClick="createDetails"
      />
    </div>
  </div>
</template>
<script>
import navbar from "../components/nav-bar.vue";
import btn from "../components/button.vue";
export default {
  components: {
    navbar,
    btn,
  },
  data() {
    return {
      lefticon: require("@/assets/accountAgent/common/back.png"),
      list: [],
      loading: false,
      finished: false,
      isLoading: false,
      page: 1,
      pageSize: 10,
      allList: 11, //默认比第一页数据多1
      hasList: true,
      showdate: false,
      selectData: "全部时间",
      startTime: "请选择",
      endTime: "请选择",
      currentDate: new Date(),
      minDate: new Date(2021, 0, 1),
      selectFirst: true,
      allSelect: false,
      selectMoney: "0.00",
      slectOrderId: [],
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.page++;
        this.getInfo();

        // 加载状态结束
        this.isLoading = false;
      }, 500);
    },
    onRefresh() {
      this.page = 1;
      this.finished = false;
      this.list = [];
      this.getInfo();
    },
    getInfo() {
      if (this.page == 1) {
        this.allSelect = false;
        this.selectMoney = "0.00";
        this.slectOrderId = [];
      }
      let parm = {
        page: this.page,
        size: 10,
        supplier_number: this.$route.query.supplier_number,
      };
      if (this.selectData != "全部时间") {
        parm = {
          page: this.page,
          size: 10,
          supplier_number: this.$route.query.supplier_number,
          start_time: this.startTime,
          end_time: this.endTime,
        };
      }
      this.$api
        .post("/onorder/member/order/supplier-order-list", parm)
        .then((res) => {
          this.allList = res.total;
          if (res.total <= 0) {
            this.hasList = false;
          }
          if (res.list.length > 0) {
            for (let i in res.list) {
              this.allSelect = false;
              this.list.push(res.list[i]);
            }
          }
          this.loading = false;
          if (this.list.length >= this.allList) {
            // 数据全部加载完成
            this.finished = true;
          }
          if (this.isLoading) {
            this.$toast("刷新成功");
            this.isLoading = false;
          }
        })
        .catch((err) => {
          this.hasList = false;
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
        });
    },
    showDatePopup() {
      this.startTime = "请选择";
      this.endTime = "请选择";
      this.selectFirst = true;
      this.currentDate = new Date();
      this.changeTime(this.currentDate);

      this.showdate = true;
    },
    formatter(type, value) {
      if (type === "year") {
        return `${value}年`;
      } else if (type === "month") {
        return `${value}月`;
      }
      return value;
    },
    changeTime(value) {
      var year = this.currentDate.getFullYear();
      var month = this.currentDate.getMonth() + 1;
      var day = this.currentDate.getDate();
      if (this.selectFirst) {
        this.startTime =
          year + "-" + (month < 10 ? "0" + month : "" + month) + "-" + day;
      } else {
        this.endTime =
          year + "-" + (month < 10 ? "0" + month : "" + month) + "-" + day;
      }
    },
    confirm() {
      if (this.selectFirst) {
        this.selectFirst = false;
        this.changeTime(this.currentDate);
        return;
      }
      // if (this.startTime == "请选择") {
      //   this.$toast("请选择开始时间");
      //   return;
      // } else if (this.endTime == "请选择") {
      //   this.$toast("请选择结束时间");
      //   return;
      // }
      this.showdate = false;
      this.selectData =
        this.startTime.replace(/-/g, ".") +
        "-" +
        this.endTime.replace(/-/g, ".");
      this.page = 0;
      this.list = [];
      this.onLoad();
    },
    allTime() {
      this.showdate = false;
      this.selectData = "全部时间";
      this.startTime = "请选择";
      this.endTime = "请选择";
      this.page = 0;
      this.list = [];
      this.onLoad();
    },
    selectSingle(item) {
      item.select = !item.select;
      if (item.select) {
        this.selectMoney = (
          Number(this.selectMoney) + Number(item.goods_amount)
        ).toFixed(2);
        this.slectOrderId.push(item.order_id);
        if (this.slectOrderId.length == this.list.length) {
          this.allSelect = true;
        }
      } else {
        this.selectMoney = (
          Number(this.selectMoney) - Number(item.goods_amount)
        ).toFixed(2);
        let index = this.slectOrderId.indexOf(item.order_id);
        this.slectOrderId.splice(index, 1);
        this.allSelect = false;
      }
    },
    selectAll() {
      this.selectMoney = "0.00";
      this.slectOrderId = [];
      this.allSelect = true;
      this.list.forEach((item) => {
        item.select = true;
        this.selectMoney = (
          Number(this.selectMoney) + Number(item.goods_amount)
        ).toFixed(2);
        this.slectOrderId.push(item.order_id);
      });
    },
    notSelectAll() {
      this.allSelect = false;
      this.list.forEach((item) => {
        item.select = false;
      });
      this.selectMoney = "0.00";
      this.slectOrderId = [];
    },
    createDetails() {
      if (this.slectOrderId.length == 0) {
        this.$toast("请至少选择一个订单！");
        return;
      }
      this.$router.push({
        path: "/purchaseSupplier/bindedOrder",
        query: {
          orderIds: this.slectOrderId,
          orderMoney: this.selectMoney,
          back: 2,
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.order {
  height: 100%;
  box-sizing: border-box;
  background: #f5f6f7;

  .order_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    background-color: #fff;
    z-index: 3;
  }

  .all {
    padding: 8.8rem 0 6.3rem;
    box-sizing: border-box;
    height: 100%;

    .search {
      height: 2.1rem;
      line-height: 2.1rem;
      padding: 0 1.6rem;
      color: #2c2c2f;
      font-size: 1.2rem;
      margin-top: 1.1rem;

      span {
        float: left;
        .van-icon {
          margin-left: 0.7rem;
          width: 0.5rem;
          transform: translateY(-3px);
          transform: rotate(90deg);
          -ms-transform: rotate(90deg); /* IE 9 */
          -moz-transform: rotate(90deg); /* Firefox */
          -webkit-transform: rotate(90deg); /* Safari 和 Chrome */
          -o-transform: rotate(90deg);
        }
      }

      .icon {
        margin-top: -0.2rem;
      }
    }

    .van-pull-refresh {
      height: calc(100% - 8.4rem);
      padding: 1.2rem 1.6rem 0;
      box-sizing: border-box;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;

      .lists {
        min-height: 16.9rem;
        border-radius: 0.8rem;
        background: #fff;
        margin-bottom: 1.2rem;
        padding: 0;

        .title {
          color: #333;
          font-size: 1.2rem;
          text-align: left;
          height: 4.1rem;
          line-height: 4.1rem;
          padding: 0 1.2rem 0;
          box-sizing: border-box;
          border-bottom: solid 0.05rem #eee;

          span {
            float: right;
          }
        }

        .goods_info {
          min-height: 12.7rem;
          font-size: 1.4rem;
          color: #333;
          padding: 1.1rem 1.6rem 1.2rem 1.2rem;
          box-sizing: border-box;
          border-bottom: solid 0.05rem #eee;

          .info_box {
            position: relative;
            min-height: 8rem;

            .left {
              min-height: 8rem;
              padding: 0 6.5rem 0 12.5rem;

              .select_icon {
                width: 2rem;
                position: absolute;
                left: 0;
                top: 3rem;
              }

              .pro_img {
                width: 8rem;
                height: 8rem;
                // float: left;
                position: absolute;
                left: 3.5rem;
                top: 0;
              }

              p {
                line-height: 1.8rem;
              }

              .goods_name {
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
                white-space: normal;
              }

              .spec {
                min-height: 2rem;
                margin: 0.6rem 0 0;
                color: #999;
                font-size: 1.2rem;
              }
            }

            .right {
              float: right;
              position: absolute;
              right: 0;
              top: 0;
              min-width: 6.5rem;
              text-align: right;

              p {
                margin-bottom: 0.2rem;
                font-size: 1.3rem;

                span {
                  font-size: 1rem;
                  color: #666;
                }
              }

              .quantity {
                font-size: 1.2rem;
                color: #999;
              }
            }
          }

          .money {
            color: #999;
            line-height: 1.7rem;
            margin-top: 0.7rem;
            font-size: 1.2rem;
            padding-left: 3.4rem;
          }

          .postage {
            text-align: right;
            margin-top: 0.8rem;
          }

          .account {
            line-height: 2rem;
            margin-top: 0.8rem;
            font-size: 2rem;
            text-align: right;
            color: #333;
            font-size: 1.4rem;

            span {
              color: #ff4747;
            }
          }
        }
      }
    }

    .empty {
      padding-top: 10rem;

      .emptyMsg {
        text-align: center;

        img {
          width: 16rem;
          display: inline-block;
        }

        .tip {
          color: #cccccc;
          font-size: 1.4rem;
          margin-top: 1.7rem;
          height: 2rem;
          line-height: 2rem;
        }
      }
    }

    .loading {
      width: 100%;
      /*padding-top: 100px;*/
      text-align: center;

      img {
        width: 35%;
        margin-top: 50%;
      }
    }

    .van-popup {
      height: 43rem;

      .title {
        height: 8rem;

        .van-col {
          background: #f8f8f8;
          text-align: center;
          height: 8rem;

          p {
            color: #333;
            font-size: 1.4rem;
            line-height: 1.7rem;
          }

          .decs {
            color: #999;
            font-size: 1.2rem;
            margin: 1.8rem 0 0.6rem;
            line-height: 2rem;
          }
        }

        .active {
          background: #fff;

          span {
            display: block;
            width: 100%;
            height: 0.3rem;
            margin-top: 1.6rem;
            background: -webkit-linear-gradient(to right, #fc740c, #f41a3c);
            /* Safari 5.1 - 6.0 */
            background: -o-linear-gradient(to right, #fc740c, #f41a3c);
            /* Opera 11.1 - 12.0 */
            background: -moz-linear-gradient(to right, #fc740c, #f41a3c);
            /* Firefox 3.6 - 15 */
            background: linear-gradient(to right, #fc740c, #f41a3c);
          }
        }
      }

      /deep/.van-picker {
        height: 29rem;
        padding: 1.6rem 0;
        box-sizing: border-box;

        .van-picker__toolbar {
          display: none;
        }
      }

      .btns {
        padding-left: 1.6rem;

        .left {
          margin-right: 1.1rem;
        }
      }
    }
  }

  .countMsg {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 0 1.5rem 1.2rem;
    background: #fff;
    box-sizing: border-box;
    height: 11.2rem;

    .money {
      color: #333;
      font-size: 1.6rem;
      font-weight: 700;
      line-height: 5.2rem;
      border-bottom: solid 1px #f5f5f5;

      span {
        color: #fb6b10;
      }

      .seleceInfo {
        float: right;
        font-weight: 400;
        text-align: right;

        .selectedInfo {
          color: #333;
          font-size: 1.4rem;
          line-height: 2rem;
          margin-top: 0.8rem;
          margin-bottom: 0.3rem;
        }

        .allInfo {
          color: #999;
          font-size: 1rem;
          line-height: 1.4rem;
        }
      }
    }

    .select {
      color: #333;
      font-size: 1.4rem;
      margin-top: 1.6rem;

      img {
        width: 2rem;
        margin-right: 0.8rem;
        vertical-align: middle;
      }
    }

    .confirm_btn {
      position: fixed;
      bottom: 1.2rem;
      right: 1.5rem;
    }
  }
}
</style>




